import Vue from 'vue'
import VueRouter from 'vue-router'
import { getUrl } from '@/api/home'
import { mapMutations } from 'vuex'
import store from '@/store'
import { set } from 'lodash'
import Cookies from 'js-cookie'
Vue.use(VueRouter)
const userType1 = ''

const routes = [
  {
    path: '/',
    name: 'layout',
    component: () => import('@/views/layout/index.vue'),
    children: [
      // 首页
      {
        path: '/homePage',
        name: 'homePage',
        component: () => import('@/views/home/homePage.vue'),
        meta: {
          title: '淅企通'
        }
      },
      // 服务
      {
        path: '/service',
        name: 'service',
        component: () => import('@/views/service'),
        children: [
          /********
           *
           *
           *  赋码保护专区
           */

          {
            path: 'encodingProtection',
            name: 'encodingProtection',
            component: () => import('@/views/encodingProtection/index.vue'),
            meta: {
              title: '赋码保护专区'
            }
          },
          {
            path: 'recordList',
            name: 'recordList',
            component: () =>
              import('@/views/encodingProtection/recordList.vue'),
            meta: {
              title: '记录'
              // title: localStorage.getItem("addPageTitle"),
            }
          },
          {
            path: 'enterpriseAuth',
            name: 'enterpriseAuth',
            component: () => import('@/views/service/enterpriseAuth.vue'),
            meta: {
              title: '企业认证'
              // title: localStorage.getItem("addPageTitle"),
            }
          },
          {
            path: 'applyFor',
            name: 'applyFor',
            component: () => import('@/views/encodingProtection/applyFor.vue'),
            meta: {
              title: '执法申请'
            }
          },

          {
            path: 'applyDetail',
            name: 'applyDetail',
            component: () =>
              import('@/views/encodingProtection/applyDetail.vue'),
            meta: {
              title: '申请详情'
            }
          },
          {
            path: 'resultPage',
            name: 'resultPage',
            component: () =>
              import('@/views/encodingProtection/resultPage.vue'),
            meta: {
              title: '申请结果'
            }
          },
          {
            path: 'unApplyListPage',
            name: 'unApplyListPage',
            component: () =>
              import('@/views/encodingProtection/unApplyListPage.vue'),
            meta: {
              title: '待执法列表'
            }
          },
          // 出示证明
          {
            path: 'provePage',
            name: 'provePage',
            component: () => import('@/views/encodingProtection/provePage.vue'),
            meta: {
              title: '出示证明'
            }
          },
          // 添加执法
          {
            path: 'addRecord',
            name: 'addRecord',
            component: () => import('@/views/encodingProtection/addRecord.vue'),
            meta: {
              title: localStorage.getItem('addPageTitle')
            }
          },
          {
            path: 'examineList',
            name: 'examineList',
            component: () =>
              import('@/views/encodingProtection/examineList.vue'),
            meta: {
              title: '我的审核'
            }
          },
          {
            path: 'examineDetail',
            name: 'examineDetail',
            component: () =>
              import('@/views/encodingProtection/examineDetail.vue'),
            meta: {
              title: '审核详情'
            }
          },
          {
            path: 'policyQa',
            name: 'policyQa',
            component: () => import('@/views/service/policyQa.vue'),
            meta: {
              title: '政策问答'
            }
          },
          {
            path: 'policyQaDetail',
            name: 'policyQaDetail',
            component: () => import('@/views/service/policyQaDetail.vue'),
            meta: {
              title: '详情'
            }
          },
          // 紧急执法
          {
            path: 'emergent',
            name: 'emergent',
            component: () => import('@/views/encodingProtection/emergent.vue'),
            meta: {
              title: '紧急执法'
            }
          },
          {
            path: 'applyList',
            name: 'applyList',
            component: () => import('@/views/encodingProtection/applyList.vue'),
            meta: {
              title: '我的申请'
            }
          },
          {
            path: 'makeACopyForList',
            name: 'makeACopyForList',
            component: () =>
              import('@/views/encodingProtection/makeACopyForList.vue'),
            meta: {
              title: '抄送我的'
            }
          },
          // 通知公告
          {
            name: 'noticeList',
            path: 'noticeList',
            component: () => import('@/views/notice/noticeList.vue'),
            meta: {
              title: '通知公告'
            }
          },
          {
            name: 'noticeDetail',
            path: 'noticeDetail',
            component: () => import('@/views/notice/noticeDetail.vue'),
            meta: {
              title: '公告详情'
            }
          },
          /******
           * 共享实验室
           *
           */
          // 共享设备
          {
            path: 'shareDeviceList',
            name: 'shareDeviceList',
            component: () => import('@/views/sharedLab/shareDeviceList.vue'),
            meta: {
              title: '共享设备'
            }
          },

          // 我的需求
          {
            path: 'myDemand',
            name: 'myDemand',
            component: () => import('@/views/sharedLab/myDemand.vue'),
            meta: {
              title: '我的需求'
            }
          },

          // 我的实验
          {
            path: 'experiment',
            name: 'experiment',
            component: () => import('@/views/sharedLab/experiment.vue'),
            meta: {
              title: '我的委托'
            }
          },
          {
            path: 'abnormalPage',
            name: 'abnormalPage',
            component: () => import('@/views/sharedLab/abnormalPage.vue'),
            meta: {
              title: '异常情况'
            }
          },
          {
            path: 'experimentDetail',
            name: 'experimentDetail',
            component: () => import('@/views/sharedLab/experimentDetail.vue'),
            meta: {
              title: '实验详情'
            }
          },
          {
            path: 'newsList',
            name: 'newsList',
            component: () => import('@/views/sharedLab/newsList.vue'),
            meta: {
              title: '公示列表'
            }
          },
          {
            path: 'newsDetail',
            name: 'newsDetail',
            component: () => import('@/views/sharedLab/newsDetail.vue'),
            meta: {
              title: '公示详情'
            }
          },
          // 岗位详情
          {
            path: 'recruitDetail',
            name: 'recruitDetail',
            component: () =>
              import('@/views/doubleMovesCitations/recruitDetail.vue'),
            meta: {
              title: '岗位详情'
            }
          },
          // 招商引资现状
          {
            path: 'investmentAttractionNow',
            name: 'investmentAttractionNow',
            component: () =>
              import(
                '@/views/doubleMovesCitations/investmentAttractionNow.vue'
              ),
            meta: {
              title: '招商引资'
            }
          },
          // 招才引智现状
          {
            path: 'recruitNow',
            name: 'recruitNow',
            component: () =>
              import('@/views/doubleMovesCitations/recruitNow.vue'),
            meta: {
              title: '招才引智'
            }
          },
          {
            path: 'doubleMovesCitations',
            name: 'doubleMovesCitations',
            component: () => import('@/views/doubleMovesCitations/index.vue'),
            meta: {
              title: '双招双引'
            }
          },
          // 双招双引--产业
          {
            path: 'doubleMovesCitations',
            name: 'doubleMovesCitations',
            component: () => import('@/views/doubleMovesCitations/index.vue'),
            meta: {
              title: '双招双引'
            }
          },
          // 案例
          {
            path: 'case',
            name: 'case',
            component: () => import('@/views/home/case.vue'),
            meta: {
              title: '服务信息'
            }
          },
          // 产业详情
          {
            path: 'industryDetail',
            name: 'industryDetail',
            component: () =>
              import('@/views/doubleMovesCitations/industryDetail.vue'),
            meta: {
              title: '产业详情'
            }
          },
          // 共享实验室
          {
            path: 'sharedLab',
            name: 'sharedLab',
            component: () => import('@/views/sharedLab/index.vue'),
            meta: {
              title: '共享实验室'
            }
          },
          // 共享实验室详情
          {
            path: 'shareLabDetail',
            name: 'shareLabDetail',
            component: () => import('@/views/sharedLab/shareLabDetail.vue'),
            meta: {
              title: '实验室详情'
            }
          },
          // 设备详情
          {
            path: 'deviceDetailPage',
            name: 'deviceDetailPage',
            component: () => import('@/views/sharedLab/deviceDetailPage.vue'),
            meta: {
              title: '设备详情'
            }
          },

          // 预约列表
          {
            path: 'reservationList',
            name: 'reservationList',
            component: () => import('@/views/sharedLab/reservationList.vue'),
            meta: {
              title: '预约列表'
            }
          },
          // 设备预约
          {
            path: 'reservation',
            name: 'reservation',
            component: () => import('@/views/sharedLab/reservation.vue'),
            meta: {
              title: '实验委托'
            }
          },
          // 评价详情

          {
            path: 'deviceDetail',
            name: 'deviceDetail',
            component: () => import('@/views/sharedLab/deviceDetail.vue'),
            meta: {
              title: '评价详情'
            }
          },
          // 服务超市
          {
            path: 'supermarket',
            name: 'supermarket',
            component: () => import('@/views/supermarket/index.vue'),
            meta: {
              title: '服务超市专区'
            }
          },
          // 服务超市检索
          {
            path: 'supermarket_retrieval',
            name: 'supermarket_retrieval',
            component: () =>
              import('@/views/supermarket/supermarket_retrieval.vue'),
            meta: {
              title: '服务超市检索'
            }
          },
          // 服务超市详情
          {
            path: 'supermarket_detail',
            name: 'supermarket_detail',
            component: () =>
              import('@/views/supermarket/supermarket_detail.vue'),
            meta: {
              title: '服务详情'
            }
          },
          // 优秀服务企业
          {
            path: 'good_serviceEnterprise',
            name: 'good_serviceEnterprise',
            component: () =>
              import('@/views/supermarket/good_serviceEnterprise.vue'),
            meta: {
              title: '优秀服务企业'
            }
          },
          // 企业详情
          {
            path: 'goodEnterpriseDetail',
            name: 'goodEnterpriseDetail',
            component: () => import('@/views/supermarket/enterpriseDetail.vue'),
            meta: {
              title: '企业详情'
            }
          },
          // 服务详情
          {
            path: 'good_serviceDetail',
            name: 'good_serviceDetail',
            component: () =>
              import('@/views/supermarket/good_serviceDetail.vue'),
            meta: {
              title: '服务详情'
            }
          },
          // 服务
          {
            path: '/servicePage',
            name: 'servicePage',
            component: () => import('@/views/service/servicePage.vue'),
            meta: {
              title: '服务'
            }
          },
          // 企业服务
          {
            path: 'enterpriseServices',
            name: 'enterpriseServices',
            component: () => import('@/views/service/enterpriseServices.vue'),
            meta: {
              title: '企业服务'
            }
          },
          // 企业服务记录
          {
            path: 'serviceRecord',
            name: 'serviceRecord',
            component: () => import('@/views/service/serviceRecord.vue'),
            meta: {
              title: '企业服务记录'
            }
          },
          // 政策计算
          {
            path: 'policyCalculation',
            name: 'policyCalculation',
            component: () => import('@/views/service/policyCalculation'),
            meta: {
              title: '政策计算'
            }
          },
          // 服务详情
          {
            path: 'serviceDetail',
            name: 'serviceDetail',
            component: () => import('@/views/service/serviceDetail'),
            meta: {
              title: '服务详情'
            }
          },
          // 问题反馈
          {
            path: 'feedback',
            name: 'feedback',
            component: () => import('@/views/service/feedback'),
            meta: {
              title: '我的反馈'
            }
          },
          // 问题详情
          {
            path: 'problemDetail',
            name: 'problemDetail',
            component: () => import('@/views/service/problemDetail'),
            meta: {
              title: '问题详情'
            }
          },
          // 问题列表
          {
            path: 'problemListPage',
            name: 'problemListPage',
            component: () => import('@/views/service/problemListPage'),
            meta: {
              title: '问题列表'
            }
          },
          // 新增问题
          {
            path: 'addProblem',
            name: 'addProblem',
            component: () => import('@/views/service/addProblem'),
            meta: {
              title: '我要反馈'
            }
          },
          // 检索
          {
            path: 'retrieval',
            name: 'retrieval',
            component: () => import('@/views/service/retrieval'),
            meta: {
              title: '政策检索'
            }
          },
          // 检索详情
          {
            path: 'retrievalDetail',
            name: 'retrievalDetail',
            component: () => import('@/views/service/retrievalDetail'),
            meta: {
              title: '详情'
            }
          },
          // 政策直达
          {
            path: 'policyDirectAccess',
            name: 'policyDirectAccess',
            component: () => import('@/views/service/policyDirectAccess'),
            meta: {
              title: '政策直达'
            }
          },
          // 扫描二维码
          {
            name: 'scanCodePage',
            path: 'scanCodePage',
            component: () => import('@/views/service/scanCodePage.vue'),
            meta: {
              title: '扫描二维码'
            }
          },
          {
            name: 'scanCodePageFM',
            path: 'scanCodePageFM',
            component: () => import('@/views/service/scanCodePageFM.vue'),
            meta: {
              title: '扫描二维码'
            }
          },
          // 企业信息完善
          {
            name: 'enterpriseEdit',
            path: 'enterpriseEdit',
            component: () => import('@/views/service/enterpriseEdit.vue'),
            meta: {
              // title: localStorage.getItem("enterpriseInfo"),
            }
          },
          // 完善企业信息
          {
            name: 'perfectEnterprise',
            path: 'perfectEnterprise',
            component: () => import('@/views/service/perfectEnterprise.vue'),
            meta: {
              title: '完善企业信息'
            }
          },
          // 企业信息详情
          {
            name: 'enterpriseDetail',
            path: 'enterpriseDetail',
            component: () => import('@/views/service/enterpriseDetail.vue'),
            meta: {
              title: '企业信息详情'
            }
          },
          // 新增服务
          {
            name: 'addServiceBody',
            path: 'addServiceBody',
            component: () => import('@/views/service/addServiceBody.vue'),
            meta: {
              title: '新增服务'
            }
          },
          // 赋码保护
          // {
          //   name: "encodingProtection",
          //   path: "encodingProtection",
          //   component: () => import("@/views/service/encodingProtection.vue"),
          //   meta: {
          //     title: "赋码保护",
          //   },
          // },
          // 数据统计
          {
            name: 'dataStatistics',
            path: 'dataStatistics',
            component: () => import('@/views/service/dataStatistics.vue'),
            meta: {
              title: '数据统计'
            }
          },
          // 信息登记
          {
            name: 'registration',
            path: 'registration',
            component: () => import('@/views/service/registration.vue'),
            meta: {
              title: '信息登记'
            }
          },
          // 评价记录详情
          {
            name: 'historyDetail',
            path: 'historyDetail',
            component: () => import('@/views/service/historyDetail.vue'),
            meta: {
              title: '评价记录详情'
            }
          },
          // 检查记录
          {
            name: 'inspectRecords',
            path: 'inspectRecords',
            component: () => import('@/views/service/inspectRecords.vue'),
            meta: {
              title: '执法记录'
              // title: userType1 == 1 ? "检查记录" : "服务记录",
            }
          },
          // 赋码保护服务详情-企业端
          {
            name: 'enterpriseHistoryDetail',
            path: 'enterpriseHistoryDetail',
            component: () =>
              import('@/views/service/enterpriseHistoryDetail.vue'),
            meta: {
              title: '赋码保护服务详情'
            }
          },
          // 赋码保护-投诉建议
          {
            name: 'complaintSuggestions',
            path: 'complaintSuggestions',
            component: () => import('@/views/service/complaintSuggestions.vue'),
            meta: {
              title: '投诉建议'
            }
          },
          // 新增投诉问题
          {
            name: 'addComplaint',
            path: 'addComplaint',
            component: () => import('@/views/service/addComplaint.vue'),
            meta: {
              title: '我要投诉建议'
            }
          },
          // 投诉列表
          {
            name: 'complaintListPage',
            path: 'complaintListPage',
            component: () => import('@/views/service/complaintListPage.vue'),
            meta: {
              title: '投诉列表'
            }
          },
          // 企业变更历史
          {
            name: 'changeHistory',
            path: 'changeHistory',
            component: () => import('@/views/service/changeHistory.vue'),
            meta: {
              title: '企业变更历史'
            }
          },

          // 包联企业
          {
            name: 'associationEnterprise',
            path: 'associationEnterprise',
            component: () =>
              import('@/views/service/associationEnterprise.vue'),
            meta: {
              title: '包联企业'
            }
          },
          // 助企统计
          {
            name: 'statistics',
            path: 'statistics',
            component: () => import('@/views/service/statistics.vue'),
            meta: {
              title: '助企统计'
            }
          },
          // 我的收藏
          {
            name: 'myCollection',
            path: 'myCollection',
            component: () => import('@/views/service/myCollectionPage.vue'),
            meta: {
              title: '我的收藏'
            }
          },

          {
            name: 'enterpriseSearch',
            path: 'enterpriseSearch',
            component: () => import('@/views/service/enterpriseSearch.vue'),
            meta: {
              title: '企业码查询'
            }
          },
          // 政策推送
          {
            name: 'policyPush',
            path: 'policyPush',
            component: () => import('@/views/service/policyPush.vue'),
            meta: {
              title: '政策推送'
            }
          },
          {
            name: 'policy_implementation',
            path: 'policy_implementation',
            component: () =>
              import('@/views/service/policy_implementation.vue'),
            meta: {
              title: '政策兑现'
            }
          },
          {
            name: 'implementation_detail',
            path: 'implementation_detail',
            component: () =>
              import('@/views/service/implementation_detail.vue'),
            meta: {
              title: '政策兑现详情'
            }
          },
          // 申诉
          {
            name: 'appeal',
            path: 'appeal',
            component: () => import('@/views/service/appeal.vue'),
            meta: {
              title: '申诉'
            }
          },
          // 诉求直达
          {
            name: 'directAppeal',
            path: 'directAppeal',
            component: () => import('@/views/service/directAppeal.vue'),
            meta: {
              title: '诉求直达'
            }
          },

          // 诉求进度
          {
            name: 'scheduleListPage',
            path: 'scheduleListPage',
            component: () => import('@/views/service/scheduleListPage.vue'),
            meta: {
              title: '诉求进度'
            }
          },
          // 新增诉求
          {
            name: 'addAppealPage',
            path: 'addAppealPage',
            component: () => import('@/views/service/addAppealPage.vue'),
            meta: {
              title: '提出诉求'
            }
          },
          {
            name: 'myAppealPage',
            path: 'myAppealPage',
            component: () => import('@/views/service/myAppealPage.vue'),
            meta: {
              title: '我的诉求'
            }
          },
          //
          {
            name: 'caseDetails',
            path: 'caseDetails',
            component: () => import('@/views/service/caseDetails.vue'),
            meta: {
              title: '详情'
            }
          }
        ]
      },
      // 我的
      {
        path: '/my',
        name: 'my',
        component: () => import('@/views/my'),
        children: [
          // 我的
          {
            path: '/myPage',
            name: 'myPage',
            component: () => import('@/views/my/myPage.vue'),
            meta: {
              title: '我的'
            }
          },
          // 编辑个人信息
          {
            path: 'editInfo',
            name: 'editInfo',
            component: () => import('@/views/my/editInfo.vue')
          }
        ]
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login')
  }
]
// 线上须注释
let userType = null
async function getUserType () {
  const url = location.search
  const theRequest = new Object()
  if (url.indexOf('&') != -1) {
    const str = url.substr(1)
    const strs = str.split('&')
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1]
    }
  }
  userType = theRequest.userType
  localStorage.setItem('openId', theRequest.openId)
  store.commit('setUser', userType)
}
const router = new VueRouter({
  // mode: "history",
  routes
})
router.beforeEach(async (to, from, next) => {
  window.scrollTo(0, 0)
  if (to.path == '/service/inspectRecords') {
    userType = JSON.parse(localStorage.getItem('userInfo')).userType
    if (userType == 1) {
      document.title = '检查记录'
    } else {
      document.title = '服务记录'
    }
  }
  if (to.path == '/service/enterpriseEdit') {
    document.title = localStorage.getItem('enterpriseInfo')
  }
  if (to.meta.title) {
    document.title = to.meta.title
  }

  if (to.path == '/') {
    const res = await getUrl()
    window.location.href = res.data.data
    next({ path: '/homePage' })
  } else {
    const userType = localStorage.getItem('userType')
    if (userType) {
      next()
    } else {
      if (to.path == '/homePage' || to.path == '/service/retrievalDetail') {
        next()
      } else {
        const res = await getUrl()
        window.location.href = res.data.data
        next({ path: '/homePage' })
        // getUser();
      }
    }
  }
})
export default router
